import React from 'react';
import { Skeleton } from '@mui/material';
import { AspectRatioBox } from '../aspect-ration-box';

interface ImageProp {
  aspectRatio?: number; // 宽高比
  src?: string;
  width?: number | string;
  height?: number | string;
  alt?: string;
  objectFit?: any;
}

enum ImageStatus {
  Loading = 0,
  Success = 1,
  Failuare = -1,
}

export const Image: React.FC<ImageProp> = (props: ImageProp) => {
  const { src, alt, aspectRatio, width, height } = props;

  // status: 0:加载中 1: 加载成功 -1:加载失败
  const [status, setStatus] = React.useState(ImageStatus.Loading);

  const _loadImage = () => {
    setStatus(ImageStatus.Success);
  };

  const _loadImageFail = () => {
    setStatus(ImageStatus.Failuare);
  };

  return (
    <AspectRatioBox ratio={aspectRatio} width={width} height={height}>
      {src && status !== ImageStatus.Failuare && (
        <img
          alt={alt}
          style={{
            objectFit: props.objectFit || 'cover',
            width: '100%',
            height: '100%',
          }}
          src={src}
          onLoad={_loadImage}
          onError={_loadImageFail}
        />
      )}
      {status !== ImageStatus.Success && (
        <>
          {status === ImageStatus.Loading && (
            <Skeleton
              variant="rectangular"
              animation="wave"
              height="100%"
              width="100%"
            />
          )}
          {status === ImageStatus.Failuare && (
            <Skeleton
              variant="rectangular"
              animation="wave"
              height="100%"
              width="100%"
            />
          )}
        </>
      )}
    </AspectRatioBox>
  );
};

export default Image;
